// The band over a module's pages while the firm has it switched off: the
// records stay readable, the write controls are gone, and this says why.

import { Link } from "react-router-dom";
import type { ModuleId } from "@duralex/shared";
import { useModuleOn } from "../../api/attorneyConfig";
import { useCurrentUser } from "../auth/CurrentUserContext";
import { isAdminRole } from "../../lib/roles";

export function ModuleOffNotice({ id, name }: { id: ModuleId; name: string }) {
  // Only an admin can reach the switch, so only an admin is pointed at it.
  const isAdmin = isAdminRole(useCurrentUser()?.role);
  if (useModuleOn(id)) return null;
  return (
    <div
      className="cc-card"
      style={{ padding: "10px 18px", color: "var(--muted)", marginBottom: 12 }}
      role="status"
    >
      {/* One child: the card is a flex column, and bare text beside a
          link would stack as three rows. */}
      <span>
        {name} is switched off: its records are read-only.
        {isAdmin && (
          <>
            {" "}
            Switch it on under{" "}
            <Link className="cc-link-subtle cc-link-marked" to="/settings/modules">
              Settings
            </Link>
            .
          </>
        )}
      </span>
    </div>
  );
}
